var _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcellent = function SvgExcellent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-shadow",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#96bc4b",
    d: "M9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-background"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-component-shadow",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.79 11.34c0-.2.4-.53.4-.94S14 9.72 14 9.58a2.1 2.1 0 0 0 .18-.83 1 1 0 0 0-.3-.69 1.13 1.13 0 0 0-.55-.2 10.3 10.3 0 0 1-2.07 0c-.37-.23 0-1.18.18-1.7S11.9 4 10.62 3.7c-.69-.17-.66.37-.78.9-.05.21-.09.43-.13.57a5 5 0 0 1-2.66 3.06 1.6 1.6 0 0 1-.42.18v4.94a7.2 7.2 0 0 1 1.37.18c.52.12.91.25 1.44.33A11 11 0 0 0 11 14a6.7 6.7 0 0 0 1.18 0 1.09 1.09 0 0 0 1-.59.7.7 0 0 0 .06-.2 1.6 1.6 0 0 1 .07-.3c.13-.28.37-.3.5-.68s-.07-.7-.02-.89M5.49 8.09H4.31a.5.5 0 0 0-.5.5v4.56a.5.5 0 0 0 .5.5h1.18a.5.5 0 0 0 .5-.5V8.59a.5.5 0 0 0-.5-.5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.79 10.84c0-.2.4-.53.4-.94S14 9.22 14 9.08a2.1 2.1 0 0 0 .18-.83 1 1 0 0 0-.3-.69 1.13 1.13 0 0 0-.55-.2 10.3 10.3 0 0 1-2.07 0c-.37-.23 0-1.18.18-1.7s.51-2.12-.77-2.43c-.69-.17-.66.37-.78.9-.05.21-.09.43-.13.57a5 5 0 0 1-2.71 3.03 1.6 1.6 0 0 1-.42.18v4.94A7.2 7.2 0 0 1 8 13c.52.12.91.25 1.44.33a11 11 0 0 0 1.62.16 6.7 6.7 0 0 0 1.18 0 1.09 1.09 0 0 0 1-.59.7.7 0 0 0 .06-.2 1.6 1.6 0 0 1 .07-.3c.13-.28.37-.3.5-.68s-.13-.72-.08-.88M5.49 7.59H4.31a.5.5 0 0 0-.5.5v4.56a.5.5 0 0 0 .5.5h1.18a.5.5 0 0 0 .5-.5V8.09a.5.5 0 0 0-.5-.5",
    className: "icon-component"
  }))));
};
export default SvgExcellent;